import { useState } from 'react';

export function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      quote: "Working with Hurley Associates was an absolute pleasure. Their knowledge of the St. Pete Beach market is unmatched, and they helped us find our dream beach home. The entire process was smooth and professional.",
      author: "Michael & Sarah Johnson",
      role: "Home Buyers",
      location: "St. Pete Beach"
    },
    {
      quote: "As a property owner, I trust Hurley Associates completely with my vacation rental management. They handle everything professionally and keep my property occupied year-round. Highly recommended!",
      author: "Robert Martinez",
      role: "Property Owner",
      location: "Pass-a-Grille"
    },
    {
      quote: "Three generations of expertise really shows. The team at Hurley Associates went above and beyond to help us sell our property quickly and at a great price. Their local connections made all the difference.",
      author: "Jennifer Williams",
      role: "Property Seller",
      location: "Gulf Beach Area"
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Client Testimonials
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Hear from our satisfied clients across the Gulf Coast
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-12 shadow-xl">
            <div className="mb-8">
              <i className="ri-double-quotes-l text-6xl text-teal-600 w-16 h-16 flex items-center justify-center"></i>
            </div>
            
            <p className="text-xl text-gray-800 leading-relaxed mb-8 italic">
              "{testimonials[activeIndex].quote}"
            </p>
            
            <div className="flex items-center justify-between">
              <div>
                <div className="font-bold text-gray-900 text-lg">{testimonials[activeIndex].author}</div>
                <div className="text-sm text-gray-600">{testimonials[activeIndex].role} • {testimonials[activeIndex].location}</div>
              </div>
              
              <div className="flex space-x-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveIndex(index)}
                    className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                      index === activeIndex ? 'bg-teal-600 w-8' : 'bg-gray-300'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}